var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAigHeaderGray = function SvgIconAigHeaderGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M10.268 19.023v-.002a.98.98 0 0 0 .56-.4l5.435-8.061a1 1 0 0 0 0-1.117l-5.435-8.065a.98.98 0 0 0-.56-.399V.977a1.1 1.1 0 0 0-.536 0 .98.98 0 0 0-.56.401L3.737 9.443a1 1 0 0 0 0 1.117l5.427 8.05.008.012.005.007-.005-.007m.251.256q.144.099.309.143v.002h.003c.161.044.37.045.533 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M10.268 19.023v-.002a.98.98 0 0 0 .56-.4l5.435-8.061a1 1 0 0 0 0-1.117l-5.435-8.065a.98.98 0 0 0-.56-.399V.977a1.1 1.1 0 0 0-.536 0 .98.98 0 0 0-.56.401L3.737 9.443a1 1 0 0 0 0 1.117l5.427 8.05.008.012.005.007-.005-.007m.251.256q.144.099.309.143v.002h.003c.161.044.37.045.533 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CCD1E0",
    strokeWidth: 0.3,
    d: "M3.93 10.106h12.503"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "M10 .957c-.095.01-.12.018-.16.027l-2.719 8.41c-.064.199-.096.406-.097.613h.62q0-.312.097-.614zM10.27.984l2.717 8.403q.097.301.097.613h.423q0-.312-.096-.613zM9.423 1.122a1 1 0 0 0-.251.256L3.737 9.444a1 1 0 0 0-.17.556h.574c0-.194.057-.388.17-.556zM10.611 1.176a1 1 0 0 1 .252.256l5.434 8.065c.113.169.17.363.17.557h-.574a1 1 0 0 0-.17-.557z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m10.27 19.016 2.717-8.403a2 2 0 0 0 .097-.613h.423q0 .313-.096.613zM9.423 18.878a1 1 0 0 1-.251-.256l-5.435-8.065a1 1 0 0 1-.17-.557h.574c0 .194.057.388.17.557zM10.576 18.878a1 1 0 0 0 .252-.256l5.435-8.065a1 1 0 0 0 .17-.557h-.575a1 1 0 0 1-.17.557zM10 19.056c-.118-.012-.121-.02-.16-.027L7.122 10.62a2 2 0 0 1-.097-.613h.62q0 .313.097.613z"
  })));
};
export default SvgIconAigHeaderGray;